(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-index"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-brands-index]').forEach(function (root) {
  var input = root.querySelector('[data-brands-search]');
  var empty = root.querySelector('[data-brands-empty]');
  if (!input) return;

  var filterBrands = function () {
    var query = input.value.trim().toLowerCase();
    var shown = 0;
    root.querySelectorAll('[data-brand-name]').forEach(function (item) {
      var name = (item.getAttribute('data-brand-name') || '').toLowerCase();
      var match = query === '' || name.indexOf(query) !== -1;
      item.hidden = !match;
      if (match) shown += 1;
    });
    if (empty) empty.hidden = shown !== 0;
  };

  input.addEventListener('input', filterBrands);
});

  } catch(e) { console.error(e); }
})();
})();
